@if (grid) {
  <grid [grid]="grid" />
}
